import { API_BASE_URL, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const fetchLearnerEvaluationCurrentApi = (moduleId, contentId) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/evaluation/current`,
        token: getToken(),
        uid: getUid(),
    });

export const startLearnerEvaluationApi = (moduleId, contentId) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/evaluation/start`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const submitLearnerEvaluationApi = (moduleId, contentId, payload) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/evaluation/submit`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const fetchLearnerEvaluationHistoryApi = (moduleId, contentId) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/evaluation/history`,
        token: getToken(),
        uid: getUid(),
    });
